<div class="grid-2col input-grid-gaps pt-2" style="min-width: 20rem;">
    <app-text-input class="fr-2" [form]="form" id="name" [prefix]="prefix"></app-text-input>
    <app-address-input class="fr-2" [form]="form"></app-address-input>
    <app-date-input [form]="form" id="validFrom"></app-date-input>
    <app-date-input [form]="form" id="validTo"></app-date-input>
</div>
<p-divider></p-divider>

<div class="flex justify-content-between align-items-center">
    <span>{{ prefix + 'fields.hours' | translate }}</span>
    <app-button icon="pi-plus" size="small" (clickEvent)="addHours()"></app-button>
</div>

<div class="flex-column gap justify-content-start">
    @for (hoursControl of form.controls?.hours?.controls || []; track hoursControl; let index = $index) {
        <div class="flex gap justify-content-between align-items-center pt-2">
            <app-select-input
                [form]="hoursControl"
                id="type"
                valueKey="value" Ó
                class="flex-1"
                [showClear]="false"
                [autoDisplayFirst]="true"
                [staticOptions]="workplaceFrequencyEnumOptions"
            ></app-select-input>
            <app-delete-button [hideLabel]="true" [confirmationType]="'none'" size="small"
                (clickEvent)="deleteHours(index)"></app-delete-button>
        </div>
        @if (hoursControl.controls.times.controls | userWorkplaceHoursParser:hoursControl.controls.times.controls.length; as timesData) {
            @for (timesControl of timesData | keyvalue; track timesControl) {
                <div class="flex flex-column">
                    <div class="flex justify-content-between pl-2">
                        <app-check-input
                            [form]="timesControl.value[0]"
                            id="active"
                            [label]="'calendar.dayNames.' + timesControl.key | translate"
                        ></app-check-input>
                        @if (timesControl.value[0].value.active) {
                            <app-button icon="pi-plus" size="small"
                                (clickEvent)="addDaysHours(hoursControl, $any(timesControl.key), true)"></app-button>
                        }
                    </div>
                    @if (timesControl.value[0].value.active) {
                        @for (timeControl of timesControl.value; track timeControl; let iin = $index) {
                            <div class="flex gap-small justify-content-end align-items-center pt-2">
                                <app-date-input [form]="timeControl" [timeOnly]="true" id="from"></app-date-input>
                                <app-date-input [form]="timeControl" [timeOnly]="true" id="to"></app-date-input>
                                <app-delete-button [hideLabel]="true" [confirmationType]="'none'" size="small"
                                    (clickEvent)="deleteDaysHours(hoursControl.controls.times, timeControl.value.day, iin)"></app-delete-button>
                            </div>
                        }
                    }
                </div>
            }
        }
    }
</div>
